export default __webpack_public_path__ + "static/media/Mask group.5c2cb972.png";